import classNames from 'classnames'
import { t } from 'i18next'
import { ReactNode } from 'react'
import { EmptyStateIcon, IconSearchNotFound, SuccessEmptyStateIcon, Text, TextProps } from '../../atoms'

// initial is for an initial state, such as the user hasn't created any items yet
// not-found is for search for something which is not found
// success is when all items has been handled
export type EmptyIconVariant = 'success' | 'initial' | 'not-found'

export const EmptyState = ({
  children,
  variant,
  description,
  titleOptions,
  descriptionOptions,
  showDefaultDescription,
  actionChildren,
  className
}: {
  children?: ReactNode
  description?: ReactNode
  descriptionOptions?: Omit<TextProps, 'children' | 'as'>
  titleOptions?: Omit<TextProps, 'children' | 'as'>
  variant: EmptyIconVariant
  showDefaultDescription?: boolean
  actionChildren?: ReactNode
  className?: string
}) => {
  return (
    <div className={classNames('h-[60vh]', className)}>
      <div className="flex flex-col gap-4 items-center mt-10">
        {variant === 'success' ? (
          <SuccessEmptyStateIcon />
        ) : variant === 'not-found' ? (
          <IconSearchNotFound />
        ) : (
          <EmptyStateIcon />
        )}
        <div className="flex flex-col gap-4 text-center">
          <Text as="p" textType="2xl" semiBold className="text-primary-800!" {...titleOptions}>
            {children ??
              (variant === 'success'
                ? t('glow.emptyStates.successTitle')
                : variant === 'not-found'
                  ? t('glow.emptyStates.notFoundTitle')
                  : t('glow.emptyStates.initialTitle'))}
          </Text>
          {description ? (
            <Text as="p" textType="base" {...descriptionOptions}>
              {description}
            </Text>
          ) : showDefaultDescription && variant === 'not-found' ? (
            <Text as="p" textType="base" {...descriptionOptions}>
              {t('glow.emptyStates.notFoundDescription')}
            </Text>
          ) : null}
          {actionChildren}
        </div>
      </div>
    </div>
  )
}
